import invariant from "tiny-invariant";
import { ProjectList } from "@lifeat/shared/projects/ProjectsTypes";
import { TaskListType } from "@lifeat/shared/task-management/TaskManagementTypes";
import { computed, signal } from "@preact/signals-react";
import { ClientTaskItemType, ClientTaskListType } from "../task-management/TaskManagementTypes";

export const selectedProjectId$ = signal<string | undefined>(undefined);
export const projectList$ = signal<ProjectList>({});
export const allTasksWithProject$ = signal<TaskListType>({});
export const tasksByProjectId$ = computed(() => {
    const result: { [projectId: string]: ClientTaskListType } = {};
    for (const [taskId, task] of Object.entries(allTasksWithProject$.value)) {
        invariant(task.projectId, "The db query should have filtered out tasks without a project id");
        if (!result[task.projectId]) {
            result[task.projectId] = {};
        }
        result[task.projectId][taskId] = { ...task, isDraft: false } as ClientTaskItemType;
    }
    return result;
});
